import { useQuery } from "react-query";
import serverApi from "../_api/server.api";


export const useGetConfig = () => useQuery({
    queryKey: ["CONFIG"],
    queryFn: () => serverApi.fetchConfig()
});
